import { Pipe, PipeTransform } from '@angular/core';
import { LabelService } from '../../framework/labels/services/label.service';
import { map, Observable } from 'rxjs';

@Pipe({
  name: 'publicLabel'
})
export class PublicLabelPipe implements PipeTransform {

  constructor(private _labelService: LabelService) { }

  transform(label: string, context?: string): Observable<string> {
    label = label.toLowerCase();
    context = context?.toLowerCase();

    return this._labelService.getLabel(label, context, true).pipe(map(e => e.labelText));
  }

}
